import { userEmailHydrator } from '../../fieldOptions/hydrators'

export default [
  {
    name: 'Institution',
    prop: 'institution_id',
    type: 'autocomplete',
    references: 'admin/institutions',
    referenceProp: 'name'
  },
  {
    name: 'User',
    prop: 'user_id',
    type: 'autocomplete',
    dataHydrator: userEmailHydrator,
    references: 'admin/users',
    referenceProp: 'fullname',
    displayProp: 'displayVal'
  },
  {
    name: 'Account Holder',
    prop: 'is_account_holder',
    type: 'checkbox',
    onChange: (value, resource) => {
      if (!value && resource.is_primary_account_holder) {
        resource.is_primary_account_holder = false
      }
    }
  },
  {
    name: 'Primary Account Holder',
    prop: 'is_primary_account_holder',
    type: 'checkbox',
    showIf: resource => resource.is_account_holder
  }
]
